var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgChevronLeft = function SvgChevronLeft(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51794 6.98708L7.68154 12.1921C7.78117 12.2891 7.86064 12.4052 7.91531 12.5334C7.96998 12.6617 7.99876 12.7997 7.99996 12.9393C8.00116 13.079 7.97477 13.2174 7.92232 13.3467C7.86987 13.4759 7.79241 13.5933 7.69447 13.692C7.59652 13.7907 7.48005 13.8688 7.35185 13.9217C7.22365 13.9746 7.08629 14.0012 6.94778 14C6.80928 13.9987 6.67239 13.9697 6.54513 13.9146C6.41786 13.8595 6.30275 13.7794 6.20652 13.679L0.30542 7.73051C0.10986 7.53332 0 7.26591 0 6.98708C0 6.70825 0.10986 6.44084 0.30542 6.24365L6.20652 0.295175C6.40326 0.103632 6.66677 -0.00235606 6.94028 3.97504e-05C7.21379 0.00243556 7.47542 0.113023 7.66883 0.307985C7.86224 0.502946 7.97195 0.766681 7.97432 1.04239C7.9767 1.31809 7.87156 1.58371 7.68154 1.78203L2.51794 6.98708Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-left.ab1f7871604e78b85cd9b06fc83d5121.svg";